import type { AxiosResponse } from "axios";
import { get, postJson } from "../../../hook/request";
import type { AddFasePayload, AddFaseResponse, FaseApiItem, GetFasiResponse } from "./types";

export async function addFaseProgetto(payload: AddFasePayload): Promise<AddFaseResponse> {
  const res: AxiosResponse<AddFaseResponse> = await postJson("/progetti/addFase", payload);
  return res.data ?? { status: "ok" };
}

export async function getFasiProgetto(progettoID: number): Promise<FaseApiItem[]> {
  const res: AxiosResponse<GetFasiResponse> = await get(
    `/progetti/getFasi?progettoID=${encodeURIComponent(String(progettoID))}`
  );
  const payload = res.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}
